import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NavermapsProvider } from 'react-naver-maps';
import { AuthProvider } from './contexts/AuthContext';


// 네이버 지도 클라이언트 ID.
// 환경별로 허용 도메인이 다르므로 빌드 시 환경변수로 주입한다.
// (.env / .env.production 의 REACT_APP_NAVER_MAP_CLIENT_ID)
const NAVER_MAP_CLIENT_ID =
  process.env.REACT_APP_NAVER_MAP_CLIENT_ID || 'ds590ypic3';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <NavermapsProvider ncpClientId={NAVER_MAP_CLIENT_ID}>
        <App />
      </NavermapsProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
